export async function copyTextToClipboard(text: string) {
  if (typeof navigator === "undefined" || !navigator.clipboard?.writeText) {
    throw new Error("Copy is not available in this browser.");
  }

  await navigator.clipboard.writeText(text);
}
